Pixlee.module('MosaicApp', function(MosaicApp, App, Backbone, Marionette, $) {
    var _this = this,
        API;

    MosaicApp.on("start", function(options) {
        new MosaicApp.Show.Controller(options);
    });
});